var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "reply",
      staticStyle: { "margin-right": "20px" },
      attrs: { model: _vm.reply, rules: _vm.rules, "label-width": "60px" }
    },
    [
      _c(
        "el-form-item",
        { attrs: { label: "回复", prop: "content" } },
        [
          _c("EditorSummernote", { ref: "summernote_3" }),
          _vm._v(" "),
          _c("TicketUploadList", {
            ref: "upList2",
            on: {
              clear: function() {
                this$1.$refs.up4.clearFile()
              },
              delete: function(e) {
                this$1.$refs.up4.deleteFile(e)
              }
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("ReplyTicketButton", {
                ref: "replyBtn",
                attrs: {
                  askUpdateStatus:
                    _vm.ticket &&
                    (_vm.ticket.orderStatus === 5 ||
                      _vm.ticket.orderStatus === 6)
                },
                on: { click: _vm.addNewReply }
              }),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { title: "点我可将工单抄送给指定人" },
                  on: {
                    click: function($event) {
                      _vm.ticketCcShow = !_vm.ticketCcShow
                    }
                  }
                },
                [_vm._v("抄送(通知)")]
              ),
              _vm._v(" "),
              _c("TicketTemplateSelect", {
                on: { selected: _vm.onTicketTemplateSelected }
              }),
              _vm._v(" "),
              _c("TicketUpload", {
                ref: "up4",
                on: {
                  change: function(e) {
                    this$1.$refs.upList2.setAttachmentList(e)
                  }
                }
              }),
              _vm._v(" "),
              _c("TicketTaskFormDialog", {
                ref: "ticketTaskFormDialog",
                on: { afterPost: _vm.afterPost }
              }),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticStyle: { float: "right", "margin-left": "5px" },
                  attrs: { title: "催办此工单" },
                  on: { click: _vm.hastenTicket }
                },
                [_vm._v("催办")]
              ),
              _vm._v(" "),
              _vm.workflowButtonShow
                ? _c(
                    "el-button",
                    {
                      staticStyle: { float: "right", "margin-left": "5px" },
                      attrs: {
                        title: "清除关联工作流,并将处理人更新为发起人",
                        type: "warning"
                      },
                      on: { click: _vm.onRejectTask_0 }
                    },
                    [_vm._v("驳回")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.workflowButtonShow
                ? _c(
                    "el-button",
                    {
                      staticStyle: { float: "right" },
                      attrs: {
                        title: "如果配置了审批步骤的表单,会弹出表单",
                        type: "success"
                      },
                      on: { click: _vm.onCompleteTask_0 }
                    },
                    [_vm._v("审批")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.workflowButtonNoPermissionShow
                ? _c(
                    "el-button",
                    {
                      staticStyle: { float: "right" },
                      attrs: {
                        type: "info",
                        plain: "",
                        disabled: "",
                        title:
                          "流程中配置了需要指定的人来审批这个工单 " +
                          JSON.stringify(_vm.ticketDealUser)
                      }
                    },
                    [
                      _vm._v(
                        "需要 " + _vm._s(_vm.ticketDealUser.name) + " 审批"
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("TicketWidgetGroup", {
                attrs: {
                  group: "AfterTicketReplyButton",
                  ticketNo: _vm.ticketNo
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.ticketCcShow
        ? _c(
            "el-form-item",
            { attrs: { label: "抄送" } },
            [
              _c("NoticeUserSearch", {
                attrs: { id: _vm.reply.orderNoticeList },
                on: { change: _vm.updateNoticeIdsReply }
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticStyle: {
                    "padding-left": "20px",
                    "font-size": "12px",
                    color: "#606266"
                  }
                },
                [
                  _vm._v("选择抄送人后，点击上面的\n      "),
                  _c("b", { staticStyle: { color: "DodgerBlue" } }, [
                    _vm._v("[回复]")
                  ]),
                  _vm._v("\n      按钮，才会生效\n    ")
                ]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticStyle: {
                    "padding-left": "10px",
                    "font-size": "12px",
                    color: "#606266"
                  }
                },
                [_vm._v("左栏下方也可以修改抄送人")]
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-accae5aa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-accae5aa","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/TicketReply.vue
// module id = 724
// module chunks = 75